import { createSlice } from '@reduxjs/toolkit';

export const TreatmentSearchOptions = {
    Member: 'Member ID or Patient information',
    TreatmentId: 'Treatment ID',
    ReferralId: 'Referral ID',
    AuthId: 'Auth ID',
};

const initialState = {};

export const treatmentSlice = createSlice({
    name: 'treatment',
    initialState,
    reducers: {
        setTreatmentSearchParams(state, action) {
            const { treatmentSearchParams } = action.payload;
            return { ...state, treatmentSearchParams };
        },
        clearTreatmentSearchParams(state) {
            return { ...state, treatmentSearchParams: undefined };
        },
    },
});

export const { setTreatmentSearchParams, clearTreatmentSearchParams } = treatmentSlice.actions;
